import Enquiries from './enquiries';
import Slider from './slider';
// import Obfuscator from './email-obfuscator';

const init = function() {
  Enquiries.init();
  Slider.init();
  // Obfuscator.init();
};

document.addEventListener("DOMContentLoaded", function() {
  init();
});
